export * from './get_resources_screen_data';
